import { render, staticRenderFns } from "./meetinglist.vue?vue&type=template&id=0d2820f8&scoped=true"
import script from "./meetinglist.vue?vue&type=script&lang=js"
export * from "./meetinglist.vue?vue&type=script&lang=js"
import style0 from "./meetinglist.vue?vue&type=style&index=0&id=0d2820f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2820f8",
  null
  
)

export default component.exports